<template>
  <div class="col-sm-4 px-0">
    <div class="card">
      <div class="card-header border-0">
        <div class="d-flex justify-content-between">
          <h3 class="card-title mb-0">Cash Drawer</h3>
        </div>
      </div>
      <div class="card-body" v-if="drawer">
        <div class="row">
          <div class="col-sm-6">
            <strong>Opened At</strong>
          </div>
          <div class="col-sm-6">
            {{ moment(drawer.opened_at).format('M/D/YY h:mm A') }}
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <strong>Open Amount</strong>
          </div>
          <div class="col-sm-6">
            {{ formatDollars(drawer.open_amount) }}
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <strong>Current Amount</strong>
          </div>
          <div class="col-sm-6">
            {{ formatDollars(drawer.current_amount) }}
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <strong>Close Amount</strong>
          </div>
          <div class="col-sm-6">
            <input class="form-control custom-form-inline" type="text" v-model="formCash.amount" size="4"/>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-12">
            <jet-button @click="cashClose">Close Drawer</jet-button>
          </div>
        </div>
      </div>
      <div class="card-body" v-else>
        <div class="row">
          <div class="col-sm-6">
            <strong>Open Amount</strong>
          </div>
          <div class="col-sm-6">
            <input type="text" class="form-control custom-form-inline" v-model="formCash.amount" size="4"/>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-12">
            <jet-button icon="fas fa-cash-register" @click="cashOpen">Open Drawer</jet-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Helpers from '@/Helpers.js'
  import moment from 'moment'

  export default {
    data() {
      return {
        formCash: this.$inertia.form({
          amount: null
        }),
      }
    },
    props: {
      drawer: Object,
      has_linked: Boolean
    },
    created() {
      this.moment = moment;
    },
    methods: {
      cashOpen() {
        this.formCash.post(this.route('mtd.cash.open'));
      },
      cashClose() {
        this.formCash.post(this.route('mtd.cash.close'));
      },
      formatCurrency: Helpers.formatCurrency
    }
  }
</script>
